import { Spin } from "antd";
import * as React from "react";
import { useContext, useState } from "react";
import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import { FindTradeComponent } from "src/components/FindTradeComponent/FindTradeComponent";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import { TradeStatusEnum } from "src/services/interfaces/TradeStatusEnum";
import { ServiceContext } from "src/services/provider/Service.provider";
import ITradeBasicInfo from "../ITradeBasicInfo";
import { SearchFilterEnum } from './SearchFilterEnum';
import "./style.scss";
import { TradeDetailView } from "./TradeDetailView";
import TradeList from "./TradeList";

interface IWorkflowTradeList {
  listStatus: TradeStatusEnum[];
  listPhase: TradePhaseEnum[];
  cardTitle: string;
  children?: any;
  showArchivedTrades?: boolean;
  isArchiveEnabled?: boolean;
  showInCartorio?: boolean;
  showCartorioScheduleDate?: boolean;
  groupBy?: keyof ITradeBasicInfo;
  searchFilter?: SearchFilterEnum;
  onlySearch?: boolean;
  hideComissionEditButton?: boolean;
}

export default function WorkflowTradeList(props: IWorkflowTradeList) {
  const { tradeSearchService } = useContext(ServiceContext);

  const [loadingList, setLoadingList] = useState(false);
  const [loadingTradeDetail, setLoadingTradeDetail] = useState(false);
  const [currentTrade, setCurrentTrade] = useState<ITrade>(undefined);
  const [tradesList, setTradesList] = useState<ITradeBasicInfo[]>([]);

  function updateList() {
    setCurrentTrade(undefined);
  }

  function findSelectedTrade(tradeId: number) {
    tradeSearchService
      .getTradeDetail(tradeId)
      .then(setCurrentTrade)
      .catch(() => ShowNotification.Error("Falha na consulta", "Ocorreu um erro durante a consulta. Tente novamente."))
      .finally(() => setLoadingTradeDetail(false));
  }

  return (
    <PbrCard className="default-tabs" title={props.cardTitle} bordered={false} style={{ width: "100%" }}>
      <div className="trade-container">
        <div className="left trade-search-list">
          <FindTradeComponent
            searchFilter={props.searchFilter}
            isOnlySearch={props.onlySearch ? props.onlySearch : false}
            setCurrentTrade={setCurrentTrade}
            setLoadingList={setLoadingList}
            setTradesList={setTradesList}
            showArchivedTrades={props.showArchivedTrades}
            showInCartorio={props.showInCartorio}
            listStatus={props.listStatus}
            listPhase={props.listPhase}
          />
          <TradeList
            noDataText={"Sem dados, preencha o campo para pesquisar"}
            loadingList={loadingList}
            tradesList={tradesList}
            setCurrentTrade={setCurrentTrade}
            setLoadingTradeDetail={setLoadingTradeDetail}
            showCartorioScheduleDate={props.showCartorioScheduleDate}
          />
        </div>
        {currentTrade && (
          <div className="right trade-info">
            <div className="wrapper">
              <Spin spinning={loadingTradeDetail} tip="Carregando trade...">
                <TradeDetailView
                  isArchiveEnabled={props.isArchiveEnabled !== undefined ? props.isArchiveEnabled : true}
                  updateList={updateList}
                  currentTrade={currentTrade}
                  childrens={props.children}
                  setLoading={setLoadingTradeDetail}
                  reloadTrade={findSelectedTrade}
                  hideComissionEditButton={props.hideComissionEditButton}
                />
              </Spin>
            </div>
          </div>
        )}
      </div>
    </PbrCard>
  );
}


// WEBPACK FOOTER //
// ./src/components/Refatoracao/TradeList/WorkflowTradeList.tsx